<body>
  <app-nav-menu></app-nav-menu>
  <div class="container" style="padding:0px; max-width:1600px">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</body>
